import moment from 'moment';

export const cnpjMask = [
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];
export const cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
export const cepMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
export const insEstadualMask = [
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const phoneMask = (value) => {
  value = value.replace(/\D+/g, '');

  if (value.length <= 12) {
    return ['+', /\d/, /\d/, ' ', '(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }
  return ['+', /\d/, /\d/, ' ', '(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
};

export const formatPhone = (value = '') => {
  let phone = `${value}`.replace(/\D+/g, '');

  // assume que o usuário não informou ddi
  if (phone.length === 11 || phone.length === 10) {
    phone = `55${phone}`;
  }

  // provavelmente um celular (9 digitos) com ddi e ddd
  if (phone.length === 13) {
    return `+${phone.slice(0, 2)} (${phone.slice(2, 4)}) ${phone.slice(4, 9)}-${phone.slice(9, 13)}`;
  }
  // provavelmente um telefone (8 digitos) com ddi e ddd
  if (phone.length === 12) {
    return `+${phone.slice(0, 2)} (${phone.slice(2, 4)}) ${phone.slice(4, 8)}-${phone.slice(8, 12)}`;
  }

  return value;
};

export const formatPhoneWithoutDdi = (value = '') => {
  const phone = `${value}`.replace(/\D+/g, '');

  // provavelmente um celular (9 digitos) com ddi e ddd
  if (phone.length === 11) {
    return `(${phone.slice(0, 2)}) ${phone.slice(2, 7)}-${phone.slice(7, 11)}`;
  }
  // provavelmente um telefone (8 digitos) com ddi e ddd
  if (phone.length === 10) {
    return `(${phone.slice(0, 2)}) ${phone.slice(2, 6)}-${phone.slice(6, 10)}`;
  }

  return value;
};

export const formatCpfCnpj = (value = '') => {
  const v = value.replace(/\D+/g, '');

  if (v.length === 11) {
    return `${v.slice(0, 3)}.${v.slice(3, 6)}.${v.slice(6, 9)}-${v.slice(9, 11)}`;
  }
  if (v.length === 14) {
    return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(8, 12)}-${v.slice(12, 14)}`;
  }
  return value;
};

export const formatDate = (value = '') => {
  if (value?.replace) {
    const d = value.replace(/\D+/g, '');

    if (d.length === 8) {
      return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
    }

    return value;
  }

  if (value?.format) {
    return value.format('DD/MM/YYYY');
  }
};

export const formatDateRange = (inicio, fim) => {
  const existeInicio = inicio !== undefined;
  const existeFim = fim !== undefined;
  if (existeInicio && existeFim) {
    const start = moment(inicio).format('DD/MM/YYYY HH:mm');

    const end = moment(fim).format('DD/MM/YYYY HH:mm');
    return `${start} a ${end}`;
  }
  if (existeInicio) {
    return moment(inicio).format('DD/MM/YYYY HH:mm');
  }
  if (existeFim) {
    return moment(fim).format('DD/MM/YYYY HH:mm');
  }
  return '-';
};

/**
 * Converte uma data em ISO String para texto dd/mm/YYYY
 *
 * exemplo: '2008-09-01T00:00:00' produz '01/09/2008'
 *
 * @param {string} value data em ISO String
 */
export const fromIsoToText = (value = '') => {
  if (!value) return '';
  const [date] = `${value}`.split('T');
  return date
    .split('-')
    .reverse()
    .join('/');
};

/**
 * Converte uma data no formato dd/mm/YYYY para ISO String com hora 00:00
 *
 * exemplo: '01/09/2008' produz '2008-09-01T00:00:00'
 *
 * @param {string} value data no formato dd/mm/YYYY
 */
export const fromTextToIso = (value = '') => {
  if (!value) return '';
  return `${value}`
    .split('/')
    .reverse()
    .join('-')
    .concat('T00:00:00');
};

export const formatCep = (value = '') => {
  const c = value.replace(/\D+/g, '');

  if (c.length === 8) {
    return `${c.slice(0, 5)}-${c.slice(5, 8)}`;
  }

  return value;
};

export const formatCurrency = (value = '0') =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })
    .format(value)
    .replace('R$ ', '');

/**
 * Método do Cond21Cloud para conversão de uma string para moeda
 * @param {string} valor valor do input
 * @param {number} casasDecimais numero de casas decimais
 * @param {string} locale localização da moeda
 */
export const formatMoeda = (valor = '0,00', casasDecimais = 2, locale = 'pt-BR') => {
  valor = valor !== '' ? valor.replace(/[,|.]/g, '') : '000';
  const posicaoVirgula = Math.abs(valor.length - casasDecimais);
  valor = `${valor.substr(0, posicaoVirgula)}.${valor.substr(posicaoVirgula, valor.length)}`;

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: casasDecimais,
  }).format(valor);
};

export const RgFormat = (v0, errChar = '') => {
  const v = v0.toUpperCase().replace(/[^\dX]/g, '');
  return v.length === 8 || v.length === 9 ? v.replace(/^(\d{1,2})(\d{3})(\d{3})([\dX])$/, '$1.$2.$3-$4') : errChar + v0;
};

export const formataQuantidade = (quantidade) => {
  return quantidade !== undefined && quantidade !== null && quantidade !== '' && quantidade !== 0
    ? quantidade.toString().indexOf('.')
      ? quantidade.toString().replace('.', ',')
      : quantidade
    : '-';
};

export const removeCpfCnpjMask = (value) => {
  if (!value) return value;
  return value.toUpperCase().replace(/[^A-Z0-9]/g, '');
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};
